import {Validators} from '@angular/forms';

import {ClientUserTypesEnum, ClientUserStatusesEnum, ClientUserFilterModel, ClientUserReportModel} from '@spa/api';

import {ComponentTypesEnum} from '../../app/shared/enums';
import {FilterControlInterface} from '../../app/shared/interfaces';
import {BaseControl, Helper, SelectControl} from '../../app/shared/classes';

import {
    ReportTableData,
    ReportTableColumn,
    ReportTableConfigInterface
} from '../../app/shared/components';

export const PanelClientUserUserIdSelector = 'clientUserId';
export const PanelClientUserRelationTypeSelector = 'clientUserRelationType';
export const PanelClientUsersStorageId = 'PanelClientUsersComponent';
export const PanelClientsEditTwoFactorAuthenticationStorageId = 'PanelClientsEditTwoFactorAuthenticationComponent';
export const PanelClientsEditUsersStorageId = 'PanelClientsEditUsersComponent';

export const PanelUsersFilterControls = (): FilterControlInterface[] => {
    return [
        {
            name: ClientUserFilterModel.getStatusSelector(),
            placeholder: 'Status',
            controls: [
                new SelectControl({
                    name: ClientUserFilterModel.getStatusSelector(),
                    value: ClientUserStatusesEnum.All,
                    placeholder: 'Status',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: Helper.textsHelper()
                                .getClientUserStatusName(ClientUserStatusesEnum.All),
                            value: ClientUserStatusesEnum.All
                        },
                        {
                            label: Helper.textsHelper()
                                .getClientUserStatusName(ClientUserStatusesEnum.ForConfirmation),
                            value: ClientUserStatusesEnum.ForConfirmation
                        },
                        {
                            label: Helper.textsHelper()
                                .getClientUserStatusName(ClientUserStatusesEnum.ForVerification),
                            value: ClientUserStatusesEnum.ForVerification
                        },
                        {
                            label: Helper.textsHelper()
                                .getClientUserStatusName(ClientUserStatusesEnum.Rejected),
                            value: ClientUserStatusesEnum.Rejected
                        },
                        {
                            label: Helper.textsHelper()
                                .getClientUserStatusName(ClientUserStatusesEnum.Verified),
                            value: ClientUserStatusesEnum.Verified
                        },
                        {
                            label: Helper.textsHelper()
                                .getClientUserStatusName(ClientUserStatusesEnum.Active),
                            value: ClientUserStatusesEnum.Active
                        },
                        {
                            label: Helper.textsHelper()
                                .getClientUserStatusName(ClientUserStatusesEnum.Declined),
                            value: ClientUserStatusesEnum.Declined
                        },
                        {
                            label: Helper.textsHelper()
                                .getClientUserStatusName(ClientUserStatusesEnum.ForDeactivation),
                            value: ClientUserStatusesEnum.ForDeactivation
                        },
                        {
                            label: Helper.textsHelper()
                                .getClientUserStatusName(ClientUserStatusesEnum.Deactivated),
                            value: ClientUserStatusesEnum.Deactivated
                        },
                        {
                            label: Helper.textsHelper()
                                .getClientUserStatusName(ClientUserStatusesEnum.Blocked),
                            value: ClientUserStatusesEnum.Blocked
                        }
                    ]
                }),
            ],
            sortIndex: 1,
        },
        {
            name: ClientUserFilterModel.getNameSelector(),
            placeholder: 'Name',
            controls: [
                new BaseControl({
                    name: ClientUserFilterModel.getNameSelector(),
                    value: null,
                    placeholder: 'Name',
                    validators: [Validators.minLength(3)],
                    componentType: ComponentTypesEnum.Text
                })
            ],
            sortIndex: 2,
        },
        {
            name: ClientUserFilterModel.getAuthorityNameSelector(),
            placeholder: 'Client Name',
            controls: [
                new BaseControl({
                    name: ClientUserFilterModel.getAuthorityNameSelector(),
                    value: null,
                    placeholder: 'Client Name',
                    validators: [Validators.minLength(3)],
                    componentType: ComponentTypesEnum.Text
                })
            ],
            sortIndex: 3,
        },
        {
            name: ClientUserFilterModel.getEmailSelector(),
            placeholder: 'Email',
            controls: [
                new BaseControl({
                    name: ClientUserFilterModel.getEmailSelector(),
                    value: null,
                    placeholder: 'Email',
                    validators: [],
                    componentType: ComponentTypesEnum.Text
                })
            ],
            sortIndex: 4,
        },
        {
            name: ClientUserFilterModel.getPhoneNumberSelector(),
            placeholder: 'Phone',
            controls: [
                new BaseControl({
                    name: ClientUserFilterModel.getPhoneNumberSelector(),
                    value: null,
                    placeholder: 'Phone',
                    validators: [],
                    componentType: ComponentTypesEnum.Text
                })
            ],
            sortIndex: 5,
        },
        {
            name: ClientUserFilterModel.getIsLegalRepresentativeSelector(),
            placeholder: 'Type',
            controls: [
                new SelectControl({
                    name: ClientUserFilterModel.getIsLegalRepresentativeSelector(),
                    value: ClientUserTypesEnum.All,
                    placeholder: 'Type',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: Helper.textsHelper().getClientUserTypeName(ClientUserTypesEnum.All),
                            value: ClientUserTypesEnum.All
                        },
                        {
                            label: Helper.textsHelper().getClientUserTypeName(ClientUserTypesEnum.LegalRepresentative),
                            value: ClientUserTypesEnum.LegalRepresentative
                        },
                        {
                            label: Helper.textsHelper().getClientUserTypeName(ClientUserTypesEnum.AuthorizedPerson),
                            value: ClientUserTypesEnum.AuthorizedPerson
                        }
                    ]
                }),
            ],
            sortIndex: 6,
        }
    ];
};

export const PanelClientUsersDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: ClientUserReportModel.getStatusSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<number>({
            colId: ClientUserReportModel.getNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ClientUserReportModel.getAuthorityNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ClientUserReportModel.getUserTypeRelationSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ClientUserReportModel.getEmailSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ClientUserReportModel.getPhoneNumberSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ClientUserReportModel.getIsLegalRepresentativeSelector(),
            value: null,
            hidden: false
        })
    ];
};

export const PanelUsersDataTableConfig = (): ReportTableConfigInterface => {
    return {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: 'Status',
                selector: ClientUserReportModel.getStatusSelector(),
            }),
            new ReportTableColumn({
                label: 'Name',
                selector: ClientUserReportModel.getNameSelector(),
                colspan: 1
            }),
            new ReportTableColumn({
                label: 'Client Name',
                selector: ClientUserReportModel.getAuthorityNameSelector(),
            }),
            new ReportTableColumn({
                label: 'Client Type',
                selector: ClientUserReportModel.getUserTypeRelationSelector(),
            }),
            new ReportTableColumn({
                label: 'Email',
                selector: ClientUserReportModel.getEmailSelector(),
            }),
            new ReportTableColumn({
                label: 'Phone',
                selector: ClientUserReportModel.getPhoneNumberSelector(),
            }),
            new ReportTableColumn({
                label: 'Type',
                selector: ClientUserReportModel.getIsLegalRepresentativeSelector()
            })
        ],
        hiddenColumnIds: [],
        actionMenu: false
    };
};
